module.exports = __webpack_public_path__ + "media/scholarship_winners/lindsey-t-dff0d4be.png";